import { integrationNames } from '@ardoq/integrations/integration-sources';
import { KnowledgeBaseLink } from '@ardoq/knowledge-base';
import { IntegrationSpecificTerms } from './streams/integrationTermsDictionary/types';
/**
 * Why all dictionaries are in one place instead of being in their respective folders?
 * We use dictionaries outside of the integrations folders, so it makes sense to have them in a common place.
 */

/**
 * Why not unified the dictionaries here?
 * Unified integrations repeat that much of same business name so it's not necessary to unify them.
 */
export const microsoftEntraIdDictionary: IntegrationSpecificTerms = {
  name: integrationNames['entra-id'],
  integrationOverviewTitle: `${integrationNames['entra-id']} integration`,
  rightSidebarHeader: `Having trouble with the ${integrationNames['entra-id']} integration?`,
  rightSideBarFAQ: [
    {
      link: KnowledgeBaseLink.MICROSOFT_ENTRA_ID_INTEGRATION,
      text: `How to import ${integrationNames['entra-id']} data.`,
    },
  ],
  connectYourAccountTitle: `Connect your ${integrationNames['entra-id']} account to Ardoq to get started.`,
  connectYourAccountBtn: 'Create new connection',
};

export const excelDictionary: IntegrationSpecificTerms = {
  name: integrationNames.excel,
  integrationOverviewTitle: `${integrationNames.excel} integration`,
  tableHeader: 'Worksheets details',
  stepTitle: 'Worksheet rows contain:',
  tabsTitle: 'Worksheets',
  rightSidebarHeader: `Having trouble with the ${integrationNames.excel} importer?`,
  connectYourAccountBtn: '',
  connectYourAccountTitle: '',
  rightSideBarFAQ: [
    {
      link: KnowledgeBaseLink.ARDOQ_BUILDING_BLOCKS,
      text: 'Ardoq core concepts',
    },
    {
      link: KnowledgeBaseLink.EXCEL_INTEGRATION,
      text: `${integrationNames.excel} import guide`,
    },
  ],
};

export const jsonDictionary: IntegrationSpecificTerms = {
  name: integrationNames.json,
  integrationOverviewTitle: `${integrationNames.json} integration`,
  tableHeader: 'Data tables details',
  stepTitle: 'Table rows contain:',
  tabsTitle: 'Tables',
  rightSidebarHeader: `Having trouble with the ${integrationNames.json} importer?`,
  connectYourAccountBtn: '',
  connectYourAccountTitle: '',
  rightSideBarFAQ: [
    {
      link: KnowledgeBaseLink.ARDOQ_BUILDING_BLOCKS,
      text: 'Ardoq core concepts',
    },
  ],
};

export const serviceNowDictionary: IntegrationSpecificTerms = {
  name: integrationNames.servicenow,
  integrationOverviewTitle: `${integrationNames.servicenow} integration`,
  rightSidebarHeader: `Having trouble with the ${integrationNames.servicenow} integration?`,
  rightSideBarFAQ: [
    {
      link: KnowledgeBaseLink.SERVICENOW_IMPORT,
      text: `How to import ${integrationNames.servicenow} server data.`,
    },
    {
      link: KnowledgeBaseLink.SERVICENOW_CREATE_REFERENCES,
      text: `How to create references with ${integrationNames.servicenow} data.`,
    },
    {
      link: KnowledgeBaseLink.SERVICENOW_EXPORT,
      text: `How to export Ardoq server data to ${integrationNames.servicenow}.`,
    },
    {
      link: KnowledgeBaseLink.SERVICENOW_CSDM_MAPPING,
      text: `How to map from the ${integrationNames.servicenow} CSDM to Ardoq solutions.`,
    },
  ],
  connectYourAccountTitle: `Connect your ${integrationNames.servicenow} account to Ardoq to get started.`,
  connectYourAccountBtn: `Connect to ${integrationNames.servicenow}`,
  noConfigsMessage: `Create a new import or export to save a configuration.`,
  noSchedulesMessage: `Create a new import or export to set up a schedule.`,
};

export const awsDictionary: IntegrationSpecificTerms = {
  name: integrationNames.aws,
  integrationOverviewTitle: `${integrationNames.aws} integration`,
  rightSidebarHeader: `Having trouble with the ${integrationNames.aws} integration?`,
  rightSideBarFAQ: [
    {
      link: KnowledgeBaseLink.AWS_INTEGRATION,
      text: `How to import ${integrationNames.aws} data.`,
    },
  ],
  connectYourAccountTitle: `Connect your ${integrationNames.aws} account to Ardoq to get started.`,
  connectYourAccountBtn: 'Create new connection',
  selectRegionsLabel: 'Select regions',
  selectRegionsHelperText:
    'The geographical location of your infrastructure. Select at least one region to continue.',
  selectConnectionHelperText:
    'Select at least one connection to access your organization’s data sets.',
  selectConnectionPlaceHolder: 'Type and select a connection',
};

export const azureDictionary: IntegrationSpecificTerms = {
  name: integrationNames.azure,
  integrationOverviewTitle: `${integrationNames.azure} integration`,
  rightSidebarHeader: `Having trouble with the ${integrationNames.azure} integration?`,
  rightSideBarFAQ: [
    {
      link: KnowledgeBaseLink.AZURE_INTEGRATION,
      text: `How to import ${integrationNames.azure} data.`,
    },
  ],
  connectYourAccountTitle: `Connect your ${integrationNames.azure} account to Ardoq to get started.`,
  connectYourAccountBtn: 'Create new connection',
  selectRegionsLabel: 'Select location(s)',
  selectRegionsHelperText:
    'The geographical location of your infrastructure. Select at least one location to continue.',
  overviewWarning: {
    i18nKey: 'azure:overview.legacyNotice',
    defaultValue:
      'The Azure Resources importer replaces this one. Use Azure Resources for new and existing imports.',
  },
};
